/**
 * Map khóa/icon danh mục BĐS sang emoji hiển thị; fallback 🏠.
 */

const CATEGORY_ICON_MAP = {
  building: '🏢',
  home: '🏠',
  villa: '🏡',
  'land-plot': '📐',
  land: '📐',
  briefcase: '💼',
  store: '🏪',
  apartment: '🏢',
  house: '🏠',
  office: '💼',
};

const isEmojiLike = (value) => {
  if (!value || value.length > 4) {
    return false;
  }

  return /[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}]/u.test(value);
};

/** Trả emoji từ tên khóa hoặc chuỗi emoji sẵn có. */
export const getCategoryIcon = (icon) => {
  if (!icon) {
    return '🏠';
  }

  if (isEmojiLike(icon)) {
    return icon;
  }

  return CATEGORY_ICON_MAP[String(icon).toLowerCase()] || '🏠';
};
